<template>
  <el-dialog width="50%" :visible.sync="visible" :title="!dataForm.id ? '新增记录' :type == 'update' ?'修改记录' : '复核充值记录'" :close-on-click-modal="false" :close-on-press-escape="false" @close="qx()">
    <el-form :disabled="allDisabled" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '140px' : '120px'">

      <el-form-item  label="资金方" prop="userId">
        <div class="funding">
          <div style="width: 240px;">
            <el-select @change="selectFund()"  v-model="dataForm.userId" placeholder="请选择" filterable clearable style="width:100%">
              <el-option v-for="item in fundList" :key="item.userId" :label="item.deptName" :value="item.userId">
              </el-option>
            </el-select>
          </div>
          <div class="balance" :style="balance < 0 ? 'color:#f20f0f' : 'color:#2cb3a3'">可用余额 ￥{{balance ? balance.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0.00}}</div>
        </div>
      </el-form-item>
        <el-form-item class="styW" label="类型" prop="payType">
          <el-select @change="selectType()" v-model="dataForm.payType" placeholder="请选择" style="width:100%">
            <el-option v-for="item in fileTypeData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="styW" label="发生额" prop="accrual">
          <el-input @input="inputChange()" @focus="inputFocus()" @blur="inputBlur()" v-model="dataForm.accrual" placeholder="￥0.00"></el-input>
        </el-form-item>
      <el-form-item  label="凭证" prop="certificateUrl">
         <div>
          <el-upload
          class="upload"
            drag
            :action="uploadUrl"
            :on-success="handleSuccessFront"
            :on-error="handleErrorFront"
            :on-remove="handleRemoveFront"
            :before-upload="beforeUploadFront"
             :file-list="fileList"
          >
            <img v-if="dataForm.certificateUrl" :src="dataForm.certificateUrl" class="avatar">
            <div v-else class="card">
              <img src="../../../assets/img/upload.svg" alt="">
            </div>
          </el-upload>
         </div>
         <div class="up_tip">1.请上传资金方对公打款凭证</div>
         <div class="up_tip">2.图片大小不能超过4M,格式:jpg、png、jpeg、bmp(不支持pdf格式)</div>
      </el-form-item>

      <el-form-item class="styW" label="备注" prop="remark">
        <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-popconfirm v-if="type != 'review' && symbol == true" :title="`${dataForm.deptName}已存在 ${currentDate} 的${dataForm.payType}记录，是否继续录入？`"  placement="top-end"
        confirm-button-text='继续'
        hide-icon
        @confirm="dataFormSubmitHandle()"
      >
        <el-button :disabled="isConfirm" style="margin-left: 16px;" type="primary" slot="reference">提交复核</el-button> 
      </el-popconfirm>
      <el-button :disabled="isConfirm" v-if="type != 'review' && symbol == false" type="primary" @click="dataFormSubmitHandle()">提交复核</el-button>
      <el-button v-if="type == 'review'" :disabled="isConfirm" type="primary" plain @click="examine('reject')">拒绝</el-button>
      <el-button :disabled="isConfirm" v-if="type == 'review'" type="primary" @click="examine('pass')">生效</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce"
import Cookies from "js-cookie";
export default {
  data() {
    return {
      fileList:[],
      isConfirm: false,
      uploadUrl:`${window.SITE_CONFIG["apiURL"]}/loan/UserRealNameAuthenticationController/upload?token=${Cookies.get("token")}`,
      visible: false,
      isRequired: true,
      allDisabled:false,
      symbol:false,
      currentDate: this.formatDate(new Date()),
      fileTypeData: [],
      fundList: [],
      type:'',
      balance:0.00,
      dataForm: {
        id: "",
        userId: "",
        payType: "",
        accrual: "",
        certificateUrl: "",
        remark: "",
        deptName:"",
        status:"AWAIT_RE_CHECK"
      },
    }
  },
  computed: {
    dataRule() {
      return {
        userId: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        payType: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        accrual: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        certificateUrl: [{ required: this.isRequired, message: this.$t("validate.required"), trigger: "blur" }],
      }
    },
  },
  mounted() {
    this.getFileFData()
  },
  created(){
    this.$http.get('/sys/user/queryUserIdList').then(res=>{
      if (res.data.code !== 0) {
            return this.$message.error(res.data.msg)
      }
        this.fundList = res.data.data
    })
  },
  methods: {
    // 日期格式化
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month starts from 0
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 类型改变
    selectType(){
      console.log(223,this.dataForm.payType);
      if(this.dataForm.userId){
        this.checkDept(this.dataForm.userId)
      }
      
      if(this.dataForm.payType == '提现'){
          this.isRequired = false
          
          if(Number(this.balance) < 0 || Number(this.balance) == 0){
            this.dataForm={
              ...this.dataForm,
              accrual: '￥0.00'         
            }
            this.$message.error('余额不足，无法提现')
          }else{
            this.dataForm={
            ...this.dataForm,
            accrual: '￥' + Number(this.balance).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })         
            }
          }
        
      }else{
          this.isRequired = true
      }
    },
    // 选择资金方
    selectFund(){
      this.dataForm.deptName = this.fundList.find(item => item.userId == this.dataForm.userId).deptName
      this.getBanlance(this.dataForm.userId)
      if(this.dataForm.payType){
        this.checkDept(this.dataForm.userId)
      }
    },
    inputChange(){
      if(this.dataForm.payType == '提现'){
        if(Number(this.balance) < Number(this.dataForm.accrual)){
          this.$message.error('提现金额不能大于余额')
        }
      }
    },
    // 输入金额获取焦点
    inputFocus(){
      this.dataForm.accrual = this.dataForm.accrual.replace(/[^\d.-]/g, '')
      console.log(111,this.dataForm.accrual);
    },
    inputBlur(){
      if(isNaN(this.dataForm.accrual)){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.accrual = '￥'+Number(this.dataForm.accrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
      console.log(222,this.dataForm.accrual);
    },
     // 图片上传成功
     handleSuccessFront(res, file) {
      this.dataForm.certificateUrl = res.data
        if(res.code == 500){
          this.$message.error(res.msg);
        }
      },
      handleErrorFront(err,file){
        console.log(222,err,file);
      },
    beforeUploadFront(file) {
      console.log(333,file);
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
      const isLt3M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、PNG、BMP 或 JPEG 格式!');
      }
   
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 4MB!');
      }

      return isJPG && isLt3M;
    },
    
    // 图片删除
    handleRemoveFront(){
      this.dataForm.certificateUrl = null
    },

    // 获取文件类型数据
    async getFileFData() {
      try {
        let result = await this.$http.get(`/sys/dict/data/list?dataType=pay_type`)
        this.fileTypeData = result.data.data ? result.data.data.map((item) => ({ value:item.dictLabel, label: item.dictLabel })) : []
        this.fileTypeData = this.fileTypeData.filter(item => item.value != '消费')
      } catch (error) {
        console.log(error)
      }
    },
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
          
        }
        if(this.type == 'review'){
          this.allDisabled = true
        }else{
          this.allDisabled = false
        }
      })
    },
    getBanlance(id){
      this.$http.get(`/system/financial_details/getAvailableBalance/${id}`).then(res=>{
            // console.log(123,res);
          if (res.data.code !== 0) {
            return this.$message.error(res.data.msg)
          }
          if(res.data.data){
            this.balance = res.data.data.availableBalance
          }else{
            this.balance = '0.00'
          }
        })
    },
    // 验证资金方
    checkDept(id){
      this.$http.get(`/system/financial_details/isExist/${id}?type=${this.dataForm.payType}`).then(res=>{
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
          this.symbol = res.data.data
      })
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/system/financial_details/info/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          }
          this.getBanlance(this.dataForm.userId)
          this.checkDept(this.dataForm.userId)
          if(this.dataForm.accrual){
            this.dataForm.accrual = '￥'+Number(this.dataForm.accrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        })
        .catch(() => {})
    },
    deepCopy(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj;
      }
      let copy = Array.isArray(obj) ? [] : {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) { // 确保只复制对象自身的属性，而不是原型链上的属性
          copy[key] = this.deepCopy(obj[key]); // 递归调用深拷贝函数，以确保内部对象也被复制
        }
      }
  
      return copy; // 返回完全独立的副本
    },
    qx(){
      this.visible = false
      this.fileList = []
      this.balance = '0.00'
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false
          }
          if(this.dataForm.payType == '提现'){
            if(this.balance < 0){
              return this.$message.error('可用余额小于0无法提现')
            } else if(this.dataForm.accrual > this.balance){
              return this.$message.error('提现金额不能大于可用余额')
            }
          }
          let dataForm = this.deepCopy(this.dataForm);
          dataForm.accrual = dataForm.accrual.replace(/[^\d.-]/g, '')
          console.log(22,dataForm);
          this.isConfirm = true
          this.$http[!this.dataForm.id ? "post" : "put"](`/system/financial_details/${!this.dataForm.id ? "save" : "update"}`, dataForm)
            .then(({ data: res }) => {
              this.isConfirm = false
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.fileList = []
              this.balance = '0.00'
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit("refreshDataList")
                },
              })
            })
            .catch(() => {
              this.isConfirm = false
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    examine(type){
      if(type == 'pass'){
        this.dataForm.status = 'TAKE_EFFECT'
      }else{
        this.dataForm.status = 'RE_CHECK_REFUSE'
      }
      let dataForm = this.deepCopy(this.dataForm);
      dataForm.accrual = Number(dataForm.accrual.replace(/[^\d.-]/g, ''))
      this.isConfirm = true
      this.$http.post('/system/financial_details/review',dataForm).then(({ data: res })=>{
        console.log(343,this.isConfirm);
        this.isConfirm = false;
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t("prompt.success"),
          type: "success",
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit("refreshDataList")
          },
        })
        this.balance = '0.00'
      }).catch(() => {
              this.isConfirm = false
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog{
  min-width: 700px;
}
.styW{
  width: 360px;
 }
 .funding{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
 }
 .balance{
  text-align: center;
  margin-left: 10px;
  min-width: 180px;
  border: 1px solid  #d7d7d7;
  background-color: #f4f4f5;
  color:  #909399;
  border-radius: 4px;
  white-space: nowrap;
  padding: 0 12px;
 }
 .avatar{
  width: 100%;
  height: 100%;
 }
 .card{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
 }
 ::v-deep .el-upload-dragger{
  width:280px;
 }
 .up_tip{
  font-size: 12px;
  color:  #a59c9c;
  line-height: 20px;
  background-color: #fffbf8;
  padding-left: 4px;
  width: 540px;
 }
</style>